import GenSettingApi from "../../services/api/GenSetting";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import { getPath } from "../../utils";
import { clean } from "../../components/GenSetting/HelperFunctions";

function handleError(err) {
  console.log("error in gen-setting actions:", err);
}

export const setActiveRule = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_RULE,
    payload,
  };
};

export const setFinalConfig = (payload) => {
  return {
    type: ActionTypes.SET_FINAL_CONFIG,
    payload,
  };
};

export const setFormschema = (payload) => {
  return {
    type: ActionTypes.SET_FORM_SCHEMA,
    payload,
  };
};

export const setActiveGenSetting = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_GEN_SETTING,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_GEN_SETTING,
    payload,
  };
};

export const getFormSchema = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await GenSettingApi.getFormSchema();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setFormschema(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getGenSettingRule = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await GenSettingApi.getGenSetting();
    dispatch(setLoader(false));
    if (response) {
      const GenSettingObj = getPath(response, "general_setting", {});
      dispatch(setActiveGenSetting(GenSettingObj));
      return GenSettingObj;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getFinalConfig =
  (cityProperty = {}, generalSetting = {}) =>
  async (dispatch) => {
    try {
      var cpRules = {
        rules: [],
      };
      if (
        cityProperty &&
        cityProperty.value &&
        cityProperty.value.rules !== undefined
      ) {
        cpRules.rules = cityProperty.value.rules;
      }

      let finalPayload = {
        city_property: cpRules,
        general_setting: generalSetting.value,
      };
      dispatch(setLoader(true));
      let finalConfig = await GenSettingApi.getFinalConfig(finalPayload);
      dispatch(setLoader(false));
      if (finalConfig) {
        let finalConfigObj = getPath(finalConfig, "config", {});
        finalConfigObj = clean(finalConfigObj);
        dispatch(setFinalConfig(finalConfigObj));
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.LIST_RETRIEVAL_SUCCESS,
          })
        );
        return finalConfigObj;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const updateGenSetting = (data) => async (dispatch) => {
  try {
    const finalPayload = {
      general_setting: data,
    };
    dispatch(setLoader(true));
    let response = await GenSettingApi.updateGenSetting(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      const GenSettingObj = getPath(response, "general_setting", {});
      dispatch(resetState({ state: "activeGenSetting" }));
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
      return GenSettingObj;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
